// extracted by mini-css-extract-plugin
export default {"banner":"banner___O9FjZ","text":"text___CsU6q","link":"link___ECQwd"};